import React from "react";
import { useGetTop25Query } from "../../../../redux/service/modules/dashboard";
import PaginatedDataTable from "../../../../components/table/PaginatedDataTable";
import { useSelector } from "react-redux";
import TableLayout from "../../../../components/layout/TableLayout";

const Top25 = ({ appliedFilters }) => {
    const dateRange = useSelector((state) => state.date);

    return (
        <TableLayout>
            <PaginatedDataTable
                queryHook={useGetTop25Query}
                initialDateRange={dateRange}
                isColumnSticky={true}
                stickyColumnsCount={3}
                appliedFilters={appliedFilters}
                paginationEnabled={false}
                isClient
            />
        </TableLayout>
    );
};

export default Top25;
